module.exports = __webpack_public_path__ + "img/web-tab.b8e47c0f.png";